var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarkerFallbackWhite = function SvgMarkerFallbackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.107 6.722h6.029c.447 0 .67 0 .802.094a.5.5 0 0 1 .204.348c.02.16-.09.356-.307.747l-1.47 2.645c-.078.142-.117.213-.133.288a.5.5 0 0 0 0 .201c.016.075.055.146.134.288l1.47 2.645c.216.391.325.587.306.747a.5.5 0 0 1-.204.348c-.131.094-.355.094-.802.094H12.54c-.56 0-.84 0-1.054-.11a1 1 0 0 1-.437-.436c-.109-.214-.109-.494-.109-1.054v-2.623M7.246 21.5 3.023 4.611m1.584 6.333h7.9c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.213.109-.493.109-1.054V4.1c0-.56 0-.84-.11-1.054a1 1 0 0 0-.436-.437c-.214-.109-.494-.109-1.054-.109H4.545c-.699 0-1.048 0-1.287.145a1 1 0 0 0-.437.56c-.083.267.002.605.172 1.283z"
  })));
};
export default SvgMarkerFallbackWhite;